export enum PerformerType {
	CAREGIVER = 'caregiver',
	PATIENT = 'patient',
}
